/* ============================================================
   Lovely Colors — Audience toggle (Particulier / Pro)
   - persists in localStorage
   - sets body[data-audience]
   - dispatches `lc:audience-change` event
   - if customer is logged-in with tag `b2b-verified`, forces 'pro'
     (the server already set window.lcCustomerTags via header.liquid)
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'lc.audience';
  var BODY = document.body;
  var DEFAULT = (BODY && BODY.dataset.audienceDefault) || 'particulier';

  function readForcedFromCustomer() {
    var tags = (window.lcCustomerTags || []);
    if (Array.isArray(tags) && tags.indexOf('b2b-verified') !== -1) {
      return 'pro';
    }
    return null;
  }

  function readStored() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (_) { return null; }
  }
  function writeStored(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (_) { /* private mode etc. */ }
  }

  function apply(audience, opts) {
    opts = opts || {};
    var next = (audience === 'pro') ? 'pro' : 'particulier';
    BODY.dataset.audience = next;

    // Update all matching toggle controls
    document.querySelectorAll('[data-audience-toggle]').forEach(function (group) {
      group.querySelectorAll('button[data-audience-value]').forEach(function (btn) {
        var match = btn.dataset.audienceValue === next;
        btn.classList.toggle('on', match);
        btn.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    });

    if (!opts.silent) {
      document.dispatchEvent(new CustomEvent('lc:audience-change', {
        detail: { audience: next, forced: !!opts.forced }
      }));
    }
  }

  function init() {
    var forced = readForcedFromCustomer();
    if (forced) {
      apply(forced, { forced: true });
      // Lock the toggle visually
      document.querySelectorAll('[data-audience-toggle]').forEach(function (group) {
        group.setAttribute('data-locked', 'true');
        group.title = 'Vous êtes connecté en tant que client Pro vérifié.';
      });
      writeStored(forced);
      return;
    }
    var stored = readStored();
    apply(stored || DEFAULT, { silent: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-audience-value]');
    if (!btn) return;
    var group = btn.closest('[data-audience-toggle]');
    if (group && group.getAttribute('data-locked') === 'true') {
      e.preventDefault();
      return;
    }
    var next = btn.dataset.audienceValue;
    apply(next);
    writeStored(next);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API
  window.lcAudience = {
    get: function () { return BODY.dataset.audience || DEFAULT; },
    set: function (v) { apply(v); writeStored(v); }
  };
})();
